import React from 'react'

import ActionDelete from '@mui/icons-material/Delete'
import {
  Button, Confirm, Datagrid,
  DateField,
  List,
  ReferenceField,
  TextField, TextInput, useDataProvider, useListContext, useLogout, useNotify, useRefresh, useUnselectAll
} from 'react-admin'

import { StatusField } from 'dash/resources/user/membership/StatusField'
import AppState from 'shared/app_state'
import { UserBlock } from 'shared/molecules/UserBlock'
import { AccountScoped } from 'shared/react-admin'
import { TeamMemberListActions } from './actions'

const CustomBulkDeleteButton = () => {
  const { data, selectedIds, resource } = useListContext()
  const [open, setOpen] = React.useState(false)
  const [currentUserIncluded, setCurrentUserIncluded] = React.useState<boolean>(false)
  const logout = useLogout()
  const refresh = useRefresh()
  const notify = useNotify()
  const dataProvider = useDataProvider()
  const unselectAll = useUnselectAll(resource)

  const handleClick = () => setOpen(true)
  const handleDialogClose = () => setOpen(false)

  const handleConfirm = async () => {
    try {
      const { data: responseData } = await dataProvider.deleteMany(resource, { ids: selectedIds })

      if (currentUserIncluded) {
        logout()
      } else {
        refresh()
        notify('Members Deleted', { type: 'success' })
        unselectAll()
      }
      setOpen(false)
    } catch (e) {
      console.error(e)
      notify('Error: members not deleted', { type: 'warning' })
    }
  }

  React.useEffect(() => {
    if (
      selectedIds &&
      data
        .filter((m) => selectedIds.includes(m.id))
        .map((m) => m.user.id)
        .includes(AppState.getCurrentUser().id)
    )
      setCurrentUserIncluded(true)
    else setCurrentUserIncluded(false)
  }, [selectedIds])

  return (
    <>
      <Button label="Delete Members" style={{ color: 'red' }} onClick={handleClick}>
        <ActionDelete />
      </Button>
      <Confirm
        isOpen={open}
        title="Delete Members"
        content={
          currentUserIncluded
            ? 'Are you sure you want to delete these members, which includes your membership? You will be automatically logged out of the dash.'
            : 'Are you sure you want to delete these members?'
        }
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
      />
    </>
  )
}

const TeamMembersBulkActionButtons = () => <CustomBulkDeleteButton />

const teamFilters = [<TextInput key={'search-filter'} label="Search" source="q" alwaysOn />]

export const TeamMemberList = () => {
  return (
    <AccountScoped view="Team Member List">
      {(accountId: string) => (
        <List
          actions={<TeamMemberListActions accountId={accountId} />}
          exporter={false}
          filters={teamFilters}
          perPage={25}
          filter={{ accountId }}
        >
          <Datagrid rowClick={null} bulkActionButtons={<TeamMembersBulkActionButtons />}>
            <ReferenceField label="User" source="user.id" reference="User" link="">
              <UserBlock label="User" />
            </ReferenceField>
            <StatusField source="status" />
            <DateField source="invitedAt" label="Invited" />
            <ReferenceField label="Invited By" source="invitedBy.id" reference="User" link="">
              <TextField source="name" />
            </ReferenceField>
          </Datagrid>
        </List>
      )}
    </AccountScoped>
  )
}
